<template>
  <FormTemplate
    class="form__wrapper"
    data-anim="fade"
  >
    <FormCore
      slot="core"
      data-theme="default"
      :slots="['row-1', 'row-2']"
    >
      <FormRow
        slot="row-1"
        :slots="['name', 'email', 'message']"
      >
        <FormInput
          slot="name"
          :type="form.name.type"
          :params="form.name"
        />

        <FormInput
          slot="email"
          :type="form.email.type"
          :params="form.email"
        />

        <FormInput
          slot="message"
          :type="form.message.type"
          :params="form.message"
        />
      </FormRow>

      <FormRow
        slot="row-2"
        :slots="['privacy', 'submit']"
      >
        <FormInput
          slot="privacy"
          :type="form.privacy.type"
          :params="form.privacy"
        />


        <FormInput
          slot="submit"
          :type="form.submit.type"
          :params="form.submit"
        />
      </FormRow>
    </FormCore>
  </FormTemplate>
</template>

<script>
import FormTemplate from './Form/index.vue';
import FormCore from './Form/FormCore/index.vue';
import FormRow from './Form/FormExtra/FormRow.vue';
import FormInput from './Form/FormInput/index.vue';

export default {
  name: 'Form',

  components: {
    FormTemplate,
    FormCore,
    FormRow,
    FormInput,
  },

  data() {
    return {
      form: {
        name: {
          id: 'name',
          name: 'name',
          type: 'text',
          label: 'Nome',
          autocomplete: 'name',
          size: 100,
          required: true,
        },
        email: {
          id: 'email',
          name: 'email',
          type: 'email',
          label: 'Email',
          autocomplete: 'email',
          size: 100,
          required: true,
        },
        message: {
          id: 'message',
          name: 'message',
          type: 'textarea',
          label: 'Messaggio',
          cols: 30,
          rows: 4,
          size: 100,
          required: true,
        },
        privacy: {
          id: 'privacy',
          name: 'privacy',
          type: 'checkbox',
          choices: [{
            id: 'privacy',
            value: 'privacy',
            label: 'Accetta <a href="https://www.iubenda.com/privacy-policy/23252125" target="_blank" rel="noopener"><bdi>Privacy</bdi></a>',
          }],
          required: true,
        },
        submit: {
          id: 'submit',
          name: 'submit',
          type: 'submit',
          text: 'Invia richiesta',
          sending: 'Sending',
          sent: 'Sent',
        },
      },
    };
  },
};
</script>

<style lang="scss">
input, textarea, select {
  font-family: $font-family-base;
}
</style>
